import { Box, Checkbox, Stack, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function RuleSetSelectionRow({ item, selectedIds, onToggle }) {
    const selected = selectedIds?.has(item.id)
    const borderColor = getBorderColor()
    const backgroundColor = getBackgroundColor()

    return (
        <ListItemBox
            data-cy="rule-set-selection-row"
            role="button"
            tabIndex={0}
            onClick={handleToggle}
            onKeyDown={handleKeyDown}
            sx={{
                px: 1.5,
                py: 1.25,
                gap: 1,
                border: 1,
                borderColor,
                borderRadius: 1,
                bgcolor: backgroundColor,
                cursor: "pointer",
                alignItems: "flex-start",
                "&:hover": { bgcolor: "action.hover", borderColor: "primary.main" },
            }}
        >
            <Checkbox
                data-cy="rule-set-selection-checkbox"
                size="small"
                checked={Boolean(selected)}
                onClick={stopPropagation}
                onChange={handleCheckboxChange}
                sx={{ p: 0.25, mt: -0.25 }}
            />
            <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="subtitle2" noWrap>
                    {item.name}
                </Typography>
                <If value={item.description}>
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                        {item.description}
                    </Typography>
                </If>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Iconify icon="tabler:filter-cog" sx={{ fontSize: 16, color: "text.secondary" }} />
                    <Typography variant="caption" color="text.secondary">
                        {formatDefaultAction()}
                    </Typography>
                    <Box
                        sx={{
                            width: 4,
                            height: 4,
                            borderRadius: "50%",
                            bgcolor: "text.disabled",
                            flexShrink: 0,
                        }}
                    />
                    <Typography variant="caption" color="text.secondary">
                        {formatRuleCount()}
                    </Typography>
                </Stack>
            </Stack>
        </ListItemBox>
    )

    function handleToggle() {
        onToggle?.(item.id)
    }

    function handleKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault()
            handleToggle()
        }
    }

    function stopPropagation(event) {
        event.stopPropagation()
    }

    function handleCheckboxChange(event) {
        event.stopPropagation()
        handleToggle()
    }

    function getBorderColor() {
        if (selected) return "primary.main"
        return "divider"
    }

    function getBackgroundColor() {
        if (selected) return "action.selected"
        return "background.paper"
    }

    function formatDefaultAction() {
        if (item.defaultAction === "exclude") return "Exclude by default"
        return "Include by default"
    }

    function formatRuleCount() {
        const count = item.rules?.length ?? 0
        if (count === 1) return "1 rule"
        return `${count} rules`
    }
}
